import { render, staticRenderFns } from "./daoqitixing.vue?vue&type=template&id=5b251e3c&scoped=true&"
import script from "./daoqitixing.vue?vue&type=script&lang=js&"
export * from "./daoqitixing.vue?vue&type=script&lang=js&"
import style0 from "./daoqitixing.vue?vue&type=style&index=0&id=5b251e3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b251e3c",
  null
  
)

export default component.exports